import {
  START_LOADING_DISCOUNT_CODES,
  END_LOADING_DISCOUNT_CODES,
  FETCH_DISCOUNT_CODES,
  CREATE_DISCOUNT_CODE,
  UPDATE_DISCOUNT_CODE,
  DELETE_DISCOUNT_CODE,
  VALIDATE_DISCOUNT_CODE,
  APPLY_DISCOUNT_CODE,
  FETCH_DISCOUNT_CODE_STATS,
  DISCOUNT_CODE_ERROR,
} from "../actions/discountCodeActions";

const initialState = {
  discountCodes: [],
  stats: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10,
    hasNext: false,
    hasPrev: false,
  },
  validatedCode: null,
};

const discountCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING_DISCOUNT_CODES:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case END_LOADING_DISCOUNT_CODES:
      return {
        ...state,
        loading: false,
      };

    case FETCH_DISCOUNT_CODES:
      return {
        ...state,
        discountCodes: action.payload.data?.discountCodes || [],
        pagination: action.payload.data?.pagination || state.pagination,
        loading: false,
        error: null,
      };

    case CREATE_DISCOUNT_CODE:
      return {
        ...state,
        discountCodes: [action.payload.data.discountCode, ...state.discountCodes],
        loading: false,
        error: null,
      };

    case UPDATE_DISCOUNT_CODE:
      return {
        ...state,
        discountCodes: state.discountCodes.map((code) =>
          code._id === action.payload.data.discountCode._id
            ? action.payload.data.discountCode
            : code
        ),
        loading: false,
        error: null,
      };

    case DELETE_DISCOUNT_CODE:
      return {
        ...state,
        discountCodes: state.discountCodes.filter(
          (code) => code._id !== action.payload
        ),
        loading: false,
        error: null,
      };

    case VALIDATE_DISCOUNT_CODE:
      return {
        ...state,
        validatedCode: action.payload,
        error: null,
      };

    case APPLY_DISCOUNT_CODE:
      return {
        ...state,
        error: null,
      };

    case FETCH_DISCOUNT_CODE_STATS:
      return {
        ...state,
        stats: action.payload.data,
        loading: false,
        error: null,
      };

    case DISCOUNT_CODE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default discountCodeReducer;